import { render, staticRenderFns } from "./GifMenu.vue?vue&type=template&id=4327e6e6"
import script from "./GifMenu.vue?vue&type=script&lang=js"
export * from "./GifMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4327e6e6')) {
      api.createRecord('4327e6e6', component.options)
    } else {
      api.reload('4327e6e6', component.options)
    }
    module.hot.accept("./GifMenu.vue?vue&type=template&id=4327e6e6", function () {
      api.rerender('4327e6e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/postCreator/components/storyTab/storyMaker/stickerMenu/GifMenu.vue"
export default component.exports